<template>
  <div class="col-md-12 form-base payment-product-item">
    <div class="row thumb-section">
      <div class="col-md-auto image">
        <b-img :src="imgUrl" alt="Center image"></b-img>
      </div>
      <div class="col description">
        <p class="title">{{ title }}</p>
        <p v-if="isEvent" class="eventdata text-right">{{ $t(LangConstants.date_table_header) }} : {{ eventDate }}</p>
        <p class="desc" v-html="description"></p>
      </div>
    </div>

    <div class="row price-section" v-if="quantity != ''">
      <div class="col total-desc">
        <span class="total-text"> {{ $t(LangConstants.webshop_quantity) }} </span>
        <div class="row">
          <div class="col-md-2 mt-1">
            <my-input label="" id="first-name" name="first-name" inlinerows="true" inlinerowclasses="" inlineInputClass="col-sm-12" classes="bg-gray" :defaultText="quantity" :disabled="true"></my-input>
          </div>

          <div class="col-md-3 pl-0 mt-1">
            <small>{{ unitPrice }} {{ $t(LangConstants.webshop_per_license_text) }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row price-section ">
      <div class="col total-desc">
        <span class="total-text"> {{ $t(LangConstants.total_text) }} </span>
        <span class="subscription-type"> ({{ title }}) </span>
      </div>
      <div class="col-md-auto total-price">
        <span class=""> {{ total }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/payment-product-item.scss";
import Constants from "../../constants/index";
import common from "../../functions/index";
import MyInput from "../atoms/Input.vue";
const dayjs = require("dayjs");

export default {
  name: "webshop-product-item",
  props: {
    title: {
      type: String,
      required: true,
      default: "Sparkfore Team",
    },
    imgUrl: {
      type: String,
      required: true,
      default: "https://img.favpng.com/8/1/9/square-euclidean-vector-rectangle-shape-png-favpng-yzRYNb4L5kLDkHW0eC2SSp5TG.jpg",
    },
    total: {
      type: String,
      required: true,
      default: "000.00 SEK",
    },
    description: {
      type: String,
      default: "Product Description goes here",
    },
    event: {
      default: "",
    },
    unitPrice: {
      type: String,
      default: "",
    },
    quantity: {
      type: String,
      default: "",
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
    isEvent() {
      if (this.event == "") return false;
      if (typeof this.event == "object" && Object.keys(this.event).length == 0) return false;
      return true;
    },
    eventDate() {
      return this.event ? dayjs(common.epochToJsDate(this.event.start_date)).format("DD MMMM") : "";
    },
  },

  components: {
    MyInput,
  },
};
</script>
